var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex flex-row justify-between mt-4 mb-6",
      class: _vm.filterClasses,
    },
    [
      _c("MultiSelectComponent", {
        attrs: {
          options: _vm.isAdmin ? _vm.options : _vm.managerOptions,
          withoutLoading: "",
          placeholder: _vm.placeHolderText,
          value: _vm.selectedOption,
          getcontainerStyle: "main__selector",
        },
        on: { input: _vm.optionChange },
      }),
      _c("div", { staticClass: "flex justify-end" }, [
        _c(
          "div",
          [
            _vm.dialog
              ? _c("ProjectModal", {
                  attrs: {
                    companyId: _vm.company.id,
                    currentUser: _vm.currentUser,
                  },
                  on: {
                    close: function ($event) {
                      _vm.dialog = false
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }